import React, {useContext, useState} from 'react';
import {useLocation} from "react-router-dom";
import {useBaseComponent} from "../../../base/base-component";
import {IEmployeeDocument, IState} from "./type/employee-document-list.types";
import {downLoadDocument, fetchDocument, viewMapper} from "./action/employee-document-list.actions";
import EmployeeDocumentListView from "./employee-document-list.view";
import "../../../styles/component/employee-document-list.scss";
import UserLoginContext from "../../../context/userLoginContext";

const EmployeeDocumentList = () => {
    const {user} = useContext(UserLoginContext);
    const [loading, setLoading] = useState(true);
    const {state, updateState} = useBaseComponent<{}, IState>({}, {
        initialState: () => ({
            data: {
                docs: []
            },
            internal: {
                employeeId: ''
            }
        }),
        onInit: () => onInit()
    })

    const location = useLocation();

    async function onInit() {
        setLoading(true);
        try {
            const id = getEmployeeIdFromURL();
            const response = await fetchDocument(id);
            const mappedResult = viewMapper(response);
            updateState('data.docs', mappedResult);
        } catch (e) {
            console.log("Error while fetching documents", e)
        } finally {
            setLoading(false)
        }
    }

    function getEmployeeIdFromURL() {
        const employeeId = location.state?.empId || user?.employeeId || '';
        updateState('internal.employeeId', employeeId)
        return employeeId;
    }

    async function handleDocumentDelete(id: string) {
        const updatedList = state.data.docs.filter((item) => item.id !== id);
        updateState('data.docs', updatedList)
    }

    async function handleDownload(id: string, name: string) {
        const fileObj = await downLoadDocument(id);
        const link = document.createElement("a");
        const url = URL.createObjectURL(fileObj);
        link.href = url;
        link.download = name || "downloaded-file";
        link.click();
        URL.revokeObjectURL(url);
    }

    function updateDocumentList(docs: IEmployeeDocument[]) {
        const updatedList = [...state.data.docs, ...docs]
        updateState('data.docs', updatedList);
    }


    return (
        <EmployeeDocumentListView
            employeeId={state.internal.employeeId}
            documentList={state.data.docs}
            handleDocumentDelete={handleDocumentDelete}
            handleDownload={handleDownload}
            updateDocumentList={updateDocumentList}
            loading={loading}
        />
    )
}

export default EmployeeDocumentList;
